import { useQuery } from "@tanstack/react-query";

import {
  getGeocode,
  getPlaceAutoCompletions,
  getPublicPlaceAutoCompletions,
} from "../services/google";

const queryKey = "google";

export const useGeocode = (address: string) => {
  return useQuery({
    queryFn: async () => {
      if (address === "") {
        return null;
      }
      return getGeocode(address);
    },
    queryKey: [queryKey, "geocode", address],
    refetchOnWindowFocus: false,
  });
};

export const useAutoCompletion = (
  address: string,
  options?: { isPublic?: boolean },
) => {
  const isPublic = options?.isPublic ?? false;
  return useQuery({
    queryFn: async () => {
      if (address === "") {
        return [];
      }
      const response = isPublic
        ? await getPublicPlaceAutoCompletions(address)
        : await getPlaceAutoCompletions(address);
      return response;
    },
    queryKey: [queryKey, address, isPublic],
    refetchOnWindowFocus: false,
  });
};
